<template>
  <div class="editor-border">
    <!-- 工具栏 -->
    <Toolbar
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="toolbarMode"
      class="toolbar-bor"
    />
    <!-- 编辑器 -->
    <Editor
      :style="{'height': height+'px', 'overflowY': 'hidden'}"
      v-bind="$attrs"
      v-on="$listeners"
      :mode="editorMode"
      :defaultConfig="editorConfig"
      @onChange="onChange"
      @onBlur="onBlur"
      @onFocus="onFocus"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { isMeaningful } from "@/utils/common";
export default ({
  name: 'gj-wang-editor',
  components: { Editor, Toolbar },
  props: {
    defaultHtml: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '500'
    },
    toolbarMode: {
      type: String,
      default: 'default', // simple or default
      validator: function (value) {
        return ['simple', 'default'].indexOf(value) !== -1
      }
    },
    excludeKeys: {
      type: Array,
      default: () => {
        return ['emotion', 'insertLink', 'group-image', 'group-video', 'insertTable', 'fullScreen']
      }
    },
    editorMode: {
      type: String,
      default: 'simple', // simple or default
      validator: function (value) {
        return ['simple', 'default'].indexOf(value) !== -1
      }
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number
    }
  },
  data () {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '',
        readOnly: false
      }
    }
  },
  created() {
    this.toolbarConfig.excludeKeys = this.excludeKeys
    this.editorConfig = {
      placeholder: this.placeholder,
      readOnly: this.readOnly,
    }
    if(isMeaningful(this.maxLength)) {
      this.editorConfig.maxLength = this.maxLength
    }
  },
  watch: {
    disabled(value) {
      if(value) {
        this.editor.disable()
      }else {
        this.editor.enable()
      }
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onChange (editor) {
      let html = ''
      if(isMeaningful(editor.getText())){
        html = editor.getHtml()
      }
      this.$emit('input', html)
    },
    onBlur (ev) {
      this.$emit('blur', ev)
    },
    onFocus (ev) {
      this.$emit('focus', ev)
    },
    getText() {
      const editor = this.editor
      if (editor == null) return
      return editor.getText()
    },
    clear() {
      const editor = this.editor
      if (editor == null) return
      // 编辑器清空
      editor.clear()
    },
    insertNewContent(html) {
      const editor = this.editor
      if (editor == null) return
      editor.select([])
      editor.deleteFragment()
      editor.dangerouslyInsertHtml(html)
    },
    insertVariable(variable) {
      const editor = this.editor
      if (editor == null) return
      // 编辑器聚焦
      editor.focus()
      //恢复最近一次非 null 选区。如编辑器 blur 之后，再重新恢复选区。
      editor.restoreSelection()
      let html = `<strong style="color: #1f71f4">${variable}</strong><span style="color: #333; font-weight: 400;">&nbsp;</span>`
      editor.dangerouslyInsertHtml(html)
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.editor-border {
  border: 1px solid #ccc;
  .toolbar-bor {
    border-bottom: 1px solid #ccc;
  }
  /deep/ .w-e-bar {
    font-size: 12px;
  }
  /deep/ .w-e-text-placeholder {
    line-height: 1;
  }
  /deep/ .w-e-bar-item {
    height: 32px;
  }
  /deep/ .w-e-bar-divider {
    height: 32px;
  }
  /deep/ .w-e-bar {
    svg {
      width: 12px;
      height: 12px;
    }
    button {
      padding: 0 4px;
      height: 28px;
    }
  }
}
</style>